// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.production.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  basePath: 'https://backend.dev.myservo.co.at/servo/api',
  basePathBrokernet: 'http://localhost:8080',
  kaufpreisUi: 'https://kaufpreis.dev.myservo.co.at',
  bikeUi: 'https://bike.dev.myservo.co.at',
  techUi: 'https://elektronik.dev.myservo.co.at',
  garantieUi: 'https://garantie.dev.myservo.co.at'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
